import { useField } from 'formik'
import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import SwitchField from 'src/components/shared/ui/form/fields/SwitchField'
import TextareaField from 'src/components/shared/ui/form/fields/TextareaField'
import { FormField } from 'src/enums/Form'
import { Orden } from 'src/interfaces/Catalog'

function Datos(): JSX.Element {
  const { t } = useTranslation()

  const [orden] = useField<Orden>(
    `${FormField.ORGANO_DESTINO}.${FormField.ORGANO_DESTINO_ORDEN_JUDICIAL}`
  )

  return (
    <FieldsetGroup legend={t('form.legend.datos')}>
      <TextareaField
        id={FormField.DATOS_OBSERVACIONES}
        label={t('form.field.observaciones')}
        maxLength={1000}
        disabled={!orden.value}
      />
      <SwitchField
        id={FormField.DATOS_URGENTE}
        label={t('form.field.urgente')}
        disabled={!orden.value}
      />
    </FieldsetGroup>
  )
}

export default Datos
